import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { StateDefinitionDto } from 'src/core/models/state-definition/state-definition.dto';
import { StateDefinitionListComponent } from '../state-definition-list/state-definition-list.component';
import { StateDefinitionFormPanelComponent } from '../state-definition-form-panel/state-definition-form-panel.component';
import { StateDefinitionToolbarComponent } from '../state-definition-toolbar/state-definition-toolbar.component';

@Component({
  selector: 'app-state-definition-main',
  standalone: true,
  imports: [
    CommonModule,
    StateDefinitionToolbarComponent,
    StateDefinitionListComponent,
    StateDefinitionFormPanelComponent,
  ],
  templateUrl: './state-definition-main.component.html',
  styleUrl: './state-definition-main.component.scss',
})
export class StateDefinitionMainComponent {
  reloadVersion = 0;
  showFormPanel = false;
  selectedStatusId: number | null = null;

  openAddPanel(): void {
    this.selectedStatusId = null;
    this.showFormPanel = true;
  }

  openEditPanel(status: StateDefinitionDto): void {
    this.selectedStatusId = status.id;
    this.showFormPanel = true;
  }

  onFormVisibilityChange(visible: boolean): void {
    this.showFormPanel = visible;

    if (!visible) {
      this.selectedStatusId = null;
    }
  }

  onSaved(): void {
    this.selectedStatusId = null;
    this.reloadVersion++;
  }

  onDeleted(): void {
    this.reloadVersion++;
  }
}
